import React from 'react';
import ReactDOM from 'react-dom';
import { globalObject } from '@skbkontur/global-object';
import { Toast, ToastDataTids } from "../Toast";
export var ToastStatic = function ToastStatic() {};

ToastStatic.push = function (notification, action, showTime) {
  if (!ToastStatic.node && globalObject.document) {
    ToastStatic.node = globalObject.document.createElement('div');
    var body = globalObject.document.body;

    if (!body) {
      throw Error('There is no "body" element in "document"');
    }

    body.appendChild(ToastStatic.node);
    ReactDOM.render( /*#__PURE__*/React.createElement(Toast, {
      "data-tid": ToastDataTids.toastStatic,
      ref: function ref(el) {
        return ToastStatic.instance = el;
      }
    }), ToastStatic.node, function () {
      return ToastStatic._push(notification, action, showTime);
    });
  } else {
    ToastStatic._push(notification, action, showTime);
  }
};

ToastStatic._push = function (notification, action, showTime) {
  if (ToastStatic.instance) {
    ToastStatic.instance.push(notification, action, showTime);
  }
};

ToastStatic.close = function () {
  if (ToastStatic.instance) {
    ToastStatic.instance.close();
  }
};

ToastStatic.instance = null;